import React from "react";

const HeroItemSkeleton: React.FC = () => {
  return (
    <div className="w-full">
      <div className="relative min-h-[600px] overflow-hidden grid place-items-end">
        <div className="absolute size-full">
          <div className="relative size-full">
            <div className="absolute bg-gradient-to-t from-black/70 to-black/25 size-full min-h-[660px]"></div>
          </div>
        </div>
        <div className="container py-20 z-[2] max-w-[85vw]">
          <div className="skeleton max-sm:!rounded mb-4 max-md:max-w-md max-sm:max-w-xs w-96 h-14"></div>
          <div className="skeleton max-sm:!rounded-sm !rounded-sm my-[15px] max-sm:my-[5px] max-sm:h-5 w-full h-5"></div>
          <div className="skeleton max-sm:!rounded-sm !rounded-sm my-[15px] max-sm:my-[5px] max-sm:h-5 w-full h-5"></div>
          <div className="skeleton max-sm:!rounded-sm !rounded-sm my-[15px] max-sm:my-[5px] max-sm:h-5 w-full h-5"></div>

          <div className="my-4 flex items-center gap-3 max-sm:gap-3 flex-wrap max-sm:flex-col">
            <div className="skeleton w-48 !rounded-2xl h-16 max-sm:mb-4 max-sm:w-full max-sm:!rounded-md"></div>
            <div className="skeleton w-48 !rounded-full h-16 max-sm:h-10 max-sm:w-full max-sm:!rounded-full"></div>
          </div>
          <div className="flex gap-10 flex-wrap max-sm:flex-col max-sm:gap-5">
            <div className="skeleton max-sm:!rounded-sm h-9 w-80 max-sm:w-80 max-sm:h-7"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroItemSkeleton;
